module.exports = __webpack_public_path__ + "img/police_funny_moments.97083b82.jpg";